/**
 * Public entry point for the canonical debug-fixture framework.
 *
 * Importing this module is enough to register every migrated fixture with
 * the registry (side effect). Later canonical schemas can be introduced by
 * adding a new file next to `wall.ts` / `stair.ts` and appending its export
 * to the auto-registration list below.
 */

import { registerFixture } from './registry';
import { rampFixtures } from './ramp';
import { stairFixtures } from './stair';
import { wallFixtures } from './wall';

let initialised = false;

export function initialiseCanonicalFixtures(): void {
    if (initialised) {
        return;
    }
    initialised = true;
    // Order preserved so `listRegisteredElementTypes()` returns sorted
    // output derived from Map insertion order after we sort in the registry.
    for (const fixture of [...wallFixtures, ...stairFixtures, ...rampFixtures]) {
        registerFixture(fixture);
    }
}

initialiseCanonicalFixtures();

export {
    getFixture,
    hasRegisteredElement,
    listRegisteredElementTypes,
    listRegisteredSchemaVersions,
    listRegisteredVariants,
    registerFixture,
} from './registry';
export {
    FIXTURE_VARIANTS,
    type CanonicalFixture,
    type CanonicalPackagePayload,
    type FixtureLookupOptions,
    type FixtureMetadata,
    type FixtureVariant,
} from './types';
